export class AdminDataReportingTotals {
  verified: number;

  basic: number;

  total: number;
}
